import { nav, carousel, videoModal } from './components'
import Glide from "@glidejs/glide";
import AOS from "aos/dist/aos";
import * as header from './components/header'
//import { ajax } from './utilities'

class Praxisgemeinschaft {
    load(){
        nav.load();
        carousel.load();
        //videoModal.load();
        //header.initialize();
        AOS.init();


        function sendData(form) {
            const XHR = new XMLHttpRequest();

            // Bind the FormData object and the form element
            const FD = new FormData( form );

            // Define what happens on successful data submission
            XHR.addEventListener( "load", function(event) {
              console.log( event.target.responseText );
            } );

            // Define what happens in case of error
            XHR.addEventListener( "error", function( event ) {
              console.log( 'Oops! Something went wrong.' );
            } );

            // Set up our request
            XHR.open( "POST", form.getAttribute('action') );

            // The data sent is what the user provided in the form
            XHR.send( FD );
          }








        console.log('praxisgemeinschaft app is loaded.');
    }
}

export let praxisgemeinschaft = new Praxisgemeinschaft();